import React from "react";
import MusicSection from "@/components/MusicSection";
import { Reveal } from "@/components/Reveal";
import { usePageMeta } from "@/hooks/usePageMeta";
import { AudioLines, ShieldCheck } from "lucide-react";

export default function Music() {
  usePageMeta(
    "Music — Okaytwitchy | CHILLWOAH",
    "Stream Okaytwitchy on Apple Music, Spotify and YouTube — or play artist-owned tracks right here in the persistent CHILLWOAH player while you browse the shop."
  );

  return (
    <div data-testid="music-page">
      <header className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 sm:pt-24 pb-10">
        <p className="font-mono text-xs sm:text-sm font-semibold tracking-[0.3em] uppercase text-[#F26522]">The Sound</p>
        <h1 className="mt-4 font-display font-extrabold uppercase text-4xl sm:text-6xl lg:text-7xl text-white tracking-tight leading-[0.95]">
          Music
        </h1>
        <p className="mt-5 max-w-2xl text-lg text-zinc-300">
          Every official release lives here. Press play below and the music keeps moving while you browse — even when
          you wander into the shop.
        </p>
        <div className="rule-lux mt-8" aria-hidden="true" />
      </header>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16 sm:pb-24">
        <MusicSection full />
      </section>

      <section className="border-t border-[#1A1A22] bg-[#0F0F14]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 pb-32">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Reveal>
              <div className="flex items-start gap-5 border border-[#1A1A22] bg-[#08080A] p-6 sm:p-8">
                <AudioLines className="w-8 h-8 text-[#F26522] shrink-0" aria-hidden="true" />
                <div>
                  <h2 className="font-display font-extrabold uppercase text-xl text-white">The persistent player</h2>
                  <p className="mt-2 text-zinc-300">
                    The compact player at the bottom of every page plays artist-owned audio straight from CHILLWOAH —
                    it keeps playing while you shop. Nothing here bypasses Apple Music or Spotify; those stay in
                    their official players and links.
                  </p>
                </div>
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="flex items-start gap-5 border border-[#1A1A22] bg-[#08080A] p-6 sm:p-8">
                <ShieldCheck className="w-8 h-8 text-[#F26522] shrink-0" aria-hidden="true" />
                <div>
                  <h2 className="font-display font-extrabold uppercase text-xl text-white">No Apple Music or Spotify?</h2>
                  <p className="mt-2 text-zinc-300">
                    YouTube is the front door — every release carries a WATCH / LISTEN ON YOUTUBE route so nobody is
                    locked out of the sound.
                  </p>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
